// This file is all general utilities
// The top portion here should be used to document functions and their purpose
//
// fetchAction: simple fetch request utility
// 
//


/**
 * @typedef {fetchResponse}
 * @property {bool} isSuccessful
 * @property {json} successData - response from request, only present if successful
 * @property {json} errorData - error code from request, only available if request errors
 */

/**
 * Sends a fetch request out to indicated url
 * @param {string} url - fetch endpoint
 * @param {string} method - HTTP Request type
 * @param {string} csrfToken - Craft's CSRF Token for validation
 * @param {string} body - stringified json for body of request
 * @returns {fetchResponse} - json object with response
 */
export async function fetchAction(url, method, csrfToken, body) {
    

    let response = {}

    try {

        const request = await fetch(url, {
            method: method,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-CSRF-Token": csrfToken
            },
            body: body ?? ""
        })

        response.isSuccessful = true
        response.successData = await request.json()
        return response

    } catch(error) {
        response.isSuccessful = false
        response.errorData = error
        return response
    }

} 

/*
    createInsecureHash
    creates an insecure hash string from a different string

    @param {string} str - any string
*/
export function createInsecureHash(str) {

    let hash = 0;
    let date = new Date()

    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
    }

    // Convert to 32bit unsigned integer in base 36 and pad with "0" to ensure length is 7.
    return (hash >>> 0).toString(36).padStart(7, "0") + "-" + date.toISOString();

}